<button 
    [ngClass]="disabled ? 'disabled-button blue-button' : 'blue-button'" 
    (click)="clicked()"> 
    {{buttonTitle}} 
</button>